import React , {useEffect} from "react";
import ReactModal from "react-modal";
import { close } from "react-icons-kit/ikons/close";
import { Icon } from "react-icons-kit";

const CloseIcon = () => (
  <div style={{ color: "grey" }}>
    <Icon size={24} icon={close} />
  </div>
);

const ModalContent = ({ style, children }) => (
  <div style={style}>{children}</div>
);

//Modal.setAppElement('#BusinessCard');

const modalStyle = {
    overlay:{
      backgroundColor: 'transparent',
      position: 'absolute',
      left: '50%',
      top: '50%',
      maxWidth: '300px',
      // maxHeight: '300px',
      transform: 'translate(-50%,-50%)',
      overflow: 'none'
    },
    // content:{
    //   //position: 'static',
    //   overflow: 'none',
    //   //minWidth: '180px',
    //   // width: '50%',
    //   // height: '50%',
    //   maxHeight: '300px',
    //   margin: 'auto'
    // }
}

export default function Modal({
  isModalOpen,
  direction,
  onCloseModal,
  parentSelector,
  children,
  style
}) {
  const modalDirection = direction ? direction : "rtl";
  const onClose = () => {
    if (onCloseModal) {
      console.log('closing...')
      onCloseModal();
    }
  };


  return (
    <ReactModal 
      isOpen={isModalOpen} 
      style={{...modalStyle,...style}} 
      parentSelector={() => document.getElementById('BusinessCard')} 
      shouldCloseOnOverlayClick={true} 
      onRequestClose={onCloseModal}
      >
      <button
        onClick={() => onClose()}
        style={{
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          float: modalDirection === "rtl" ? "left" : "right"
        }}
      >
        <i>
          <CloseIcon />
        </i>
      </button>
      <ModalContent style={{ direction: modalDirection }}>

        {children}
      </ModalContent>
    </ReactModal>
  );
}
